import styled from 'styled-components'

export default styled.header`
    position: fixed;
    background-color: #fff;
    z-index: 2;
    height: 5rem;
    display: flex;
    align-items: center;
    width: 100%;
    border-bottom: 3px solid red;
    -webkit-transition: height 300ms ease-out;
    -o-transition: height 300ms ease-out;
    transition: height 300ms ease-out;

    &.show {
        display: flex;
        @media only screen and (max-width: 799px) {
            height: 21.7em;
            overflow: hidden;
            -webkit-transition: height 300ms ease-in;
            -o-transition: height 300ms ease-in;
            transition: height 300ms ease-in;
        }
    }

    /* @media only screen and (max-width: 799px) {
        div:last-child {
            width: 100%;
            height: 300px;
            position: absolute;
            background: #4a4a4a;
        } */

`


// WEBPACK FOOTER //
// ./src/components/Header.js